module.exports = __webpack_public_path__ + "static/img/xby.eb7fee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/xby.png
// module id = iyAl
// module chunks = 1